import { throwInDev } from '@work4all/utils';

import { UseEntityRecordMatcherProps } from '../../types';
import { TargetEntityRecordMatcherConfigs } from '../types';

import { ENTITY_RECORD_MATCHER_CONFIGS_BY_TARGET_ENTITY } from './target-entities-configs';

type Props = Pick<UseEntityRecordMatcherProps, 'targetEntity'>;

export const getTargetEntityRecordMatcherConfig = <TData>({
  targetEntity,
}: Props): TargetEntityRecordMatcherConfigs<TData> => {
  const config = ENTITY_RECORD_MATCHER_CONFIGS_BY_TARGET_ENTITY[
    targetEntity
  ] as TargetEntityRecordMatcherConfigs<TData>;

  if (!config) {
    throwInDev(`No request config found for entity ${targetEntity}`);
    return null;
  }

  return config;
};
